"use strict";

const nl = {
  save: 'Opslaan',
  selectSingle: 'Selecteer datum',
  selectMultiple: 'Selecteer datums',
  selectRange: 'Selecteer periode',
  notAccordingToDateFormat: inputFormat => `Datumformaat moet ${inputFormat} zijn`,
  mustBeHigherThan: date => `Moet later dan ${date}`,
  mustBeLowerThan: date => `Moet eerder dan ${date}`,
  mustBeBetween: (startDate, endDate) => `Moet tussen ${startDate} - ${endDate}`,
  dateIsDisabled: 'Deze dag mag niet',
  previous: 'Vorige',
  next: 'Volgende',
  typeInDate: 'Typ datum',
  pickDateFromCalendar: 'Kies datum van kalender',
  close: 'Sluit',
  hour: 'Uur',
  minute: 'Minuut'
};
export default nl;
//# sourceMappingURL=nl.js.map